<template>
  <div>
    {{ ActDescBtn }}
    <table
      style="position: absolute"
      width="100%"
      :height="this.windowSize.height - 8"
      :max-height="this.windowSize.height - 8"
    >
      <tr max-height="48px" height="48px">
        <ContenidoBase
          :titulo="'Utilitario Codificación Contable'"
          :descripcion="'Utilitario Codificación Contable'"
          :EstadoBtn="EstadoBtn"
          @abrirBarraTablaDinamica="abrirTabla"
          @MethodNuevo="newwnuevo"
          @MethodGuardar="save"
          @MethodEliminar="remove"
          @MethodAnular="anular"
          @MethodImprimir="imprimirList"
        />
      </tr>

      <!-- BarraPrimaria --------------------------------------------------------------------------------->
      <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraPrimariaAbrir">
        <div
          class="overflow-y-auto"
          v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
        >
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <center>
                <v-btn-toggle>
                  <v-btn small color="yellow accent-4" @click.prevent="actualiza_tb_ver">
                    <i style="font-size: 25px" class="fa fa-eye"></i>
                    ver
                  </v-btn>
                  <v-btn small dark color="deep-purple accent-2" @click.prevent="notifi('Seguro que desea nuevo', 'n')">
                    <i style="font-size: 25px" class="fa fa-print"></i>
                    Listado
                  </v-btn>
                </v-btn-toggle>
              </center>
              <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitUtilitarioRecIng'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
            </template>
          </v-tooltip>
        </div>
      </td>
      <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
      <!-- contenido central ------------------------------------------------------------------------------ -->
      <td :max-height="this.windowSize.height - 96">
        <v-app id="inspire" class="overflow-y-auto" v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">
          <div class="px-2">
            <v-card color="grey lighten-3">
              <div class="px-2" style="border: 1px solid #000000">
                <v-form ref="formFactVenta" @submit.prevent="" v-model="valid" lazy-validation>
                  <!-- row 1  ---------------------------------------->
                  <v-row>
                    <v-col cols="12" md="6" sm="6"  >
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-on="on"
                            dense
                            outlined
                            type="date"
                            label="Fecha Inicial"
                            v-model="datoHeader.fechaInicial"
                            :rules="[$rules.required]"
                            placeholder=" "
                            style="font-size: 12px"
                            @blur="BlurDesde"
                            hide-details

                          >
                            <template v-slot:prepend>
                              <i style="font-size: 18px" class="fa fa-calendar"></i>
                            </template>
                          </v-text-field>
                        </template>
                        <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                          <span>Aquí se registra la fecha a partir de la cual queremos la búsqueda.</span>
                        </i>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="12" md="6" sm="6">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-on="on"
                            dense
                            outlined
                            type="date"
                            label="Fecha Final"
                            v-model="datoHeader.fechaFinal"
                            :rules="[$rules.required]"
                            placeholder=" "
                            style="font-size: 12px"
                            @blur="BlurHasta"
                            hide-details
                          >
                            <template v-slot:prepend>
                              <i style="font-size: 18px" class="fa fa-calendar"></i>
                            </template>
                          </v-text-field>
                        </template>
                        <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                          <span>Aquí se registra la fecha hasta donde queremos la búsqueda.</span>
                        </i>
                      </v-tooltip>
                    </v-col>

                  </v-row>
                  <!-- fn row 1  ---------------------------------------->
              
              <!--  col btn 1  ---------------------------------------->
                <v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0"> 
                <v-row>
                  <!-- col 1  ---------------------------------------->
                      <v-col cols="12" md="6" sm="6" >


                      <!--  1- col Codificación Facturas Ventas--------- -->
                      <v-col cols="12" md="12" sm="12"  >
                        <!-- <i style="font-size: 25px;" class="fa fa-search"> </i> -->
                      <v-btn color="teal darken-2" dark  small @click.prevent="getSqlCodificacioContable(1)"> 1- Codificación Facturas Ventas</v-btn>
                      <v-combobox class="pt-2 "
                            v-model="datoHeader.documentoFactVent"
                            autocomplete="off"
                            dense
                            outlined
                            label="Documentos Facturas ventas:"
                            :items="RDocumentoFactVent"
                            item-text="descripcion"
                            @blur="SelctCbDocumentoFacVent"
                            @focus="cargarDocumentoFactVent"
                            style="font-size: 13px"
                            hide-details
                          >
                          <template v-slot:selection="{ attrs, item, parent, selected }">
                          <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.descripcion.trim()}}</span>
                           <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                           </template>

                            <template v-slot:prepend-inner>
                              <i style="font-size: 20px" class="fa fa-book"></i>
                            </template>
                      </v-combobox>
                        </v-col>

                      <!--  1- col 2- Codificación devoluciones Punto --------- -->
                      
                        <v-col cols="12" md="12" sm="12" >
                          <v-btn color="teal darken-2" dark small @click.prevent="getSqlCodificacioContable(2)">2- Codificación devoluciones Punto </v-btn>
                          <v-combobox class="pt-2 "
                            v-model="datoHeader.documentoDevVent"
                            autocomplete="off"
                            dense
                            outlined
                            label="Documentos devoluciones Punto:"
                            :items="RDocumentoDevVent"
                            item-text="descripcion"
                            @blur="SelctCbDocumentoDevVent"
                            @focus="cargarDocumentoDevVent"
                            style="font-size: 13px"
                            hide-details
                          >
                          <template v-slot:selection="{ attrs, item, parent, selected }">
                          <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.descripcion.trim()}}</span>
                           <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                           </template>
                            <template v-slot:prepend-inner>
                              <i style="font-size: 20px" class="fa fa-book"></i>
                            </template>
                          </v-combobox>
                        </v-col>


                           <!--  1- col 3-Codificación Notas Crédito Clientes CXC --------- -->
                          <v-col cols="12" md="12" sm="12" >
                            <v-btn color="teal darken-2" dark  small @click.prevent="getSqlCodificacioContable(3)">3- Codificación Notas Crédito Clientes CXC</v-btn>
                            <v-combobox class="pt-2 "
                            v-model="datoHeader.documentoNotaCreditoCxc"
                            autocomplete="off"
                            dense
                            outlined
                            label="Documentos Notas Crédito Clientes CXC:"
                            :items="RDocumentoNotaCreditoCxc"
                            item-text="descripcion"
                            @blur="SelctCbDocumentoNotaCreditoCxc"
                            @focus="cargarDocumentoNotaCreditoCxc"
                            style="font-size: 13px"
                            hide-details
                          >
                          <template v-slot:selection="{ attrs, item, parent, selected }">
                          <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.descripcion.trim()}}</span>
                           <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                           </template>

                            <template v-slot:prepend-inner>
                              <i style="font-size: 20px" class="fa fa-book"></i>
                            </template>
                          </v-combobox>
                          </v-col>
                            <!--  1- col 4- Codificación Recibos Otros Ingresos --------- -->
                          <v-col cols="12" md="12" sm="12" >
                          <v-btn color="teal darken-2" dark  small @click.prevent="getSqlCodificacioContable(4)"> 4- Codificación Recibos Otros Ingresos</v-btn>
                          <v-combobox class="pt-2 "
                            v-model="datoHeader.documentoOtrosIngreso"
                            autocomplete="off"
                            dense
                            outlined
                            label="Documentos Recibos Otros Ingresos:"
                            :items="RDocumentoOtrosIngreso"
                            item-text="descripcion"
                            @blur="SelctCbDocumentoOtrosIngresos"
                            @focus="cargarDocumentoOtrosIngreso"
                            style="font-size: 13px"
                            hide-details
                          >
                          <template v-slot:selection="{ attrs, item, parent, selected }">
                          <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.descripcion.trim()}}</span>
                           <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                           </template>

                            <template v-slot:prepend-inner>
                              <i style="font-size: 20px" class="fa fa-book"></i>
                            </template>
                          </v-combobox>
                          </v-col>
                        <!--  1- col 5- Codificación Recibos de Ingreso --------- -->
                          <v-col cols="12" md="12" sm="12" >
                            <v-btn color="teal darken-2" dark  small @click.prevent="getSqlCodificacioContable(5)"> 5- Codificación Recibos de Ingreso</v-btn>
                            <v-combobox class="pt-2 "
                            v-model="datoHeader.documentoReciboIngreso"
                            autocomplete="off"
                            dense
                            outlined
                            label="Documentos Recibos de Ingreso:"
                            :items="RDocumentoReciboIngreso"
                            item-text="descripcion"
                            @blur="SelctCbDocumentoReciboIngreso"
                            @focus="cargarDocumentoReciboIngreso"
                            style="font-size: 13px"
                            hide-details
                          >
                          <template v-slot:selection="{ attrs, item, parent, selected }">
                          <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.descripcion.trim()}}</span>
                           <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                           </template>

                            <template v-slot:prepend-inner>
                              <i style="font-size: 20px" class="fa fa-book"></i>
                            </template>
                          </v-combobox>
                          </v-col>
                    <!--  1- col 6- Codificación Notas Debito Banco --------- -->
                            <v-col cols="12" md="12" sm="12" >
                              <v-btn color="teal darken-2" dark  small @click.prevent="getSqlCodificacioContable(6)"> 6- Codificación Notas Debito Banco
                            </v-btn>
                            <v-combobox class="pt-2 "
                            v-model="datoHeader.documentoNotaDebitoBanco"
                            autocomplete="off"
                            dense
                            outlined
                            label="Documentos Notas Debito Banco:"
                            :items="RDocumentoNotaDebitoBanco"
                            item-text="descripcion"
                            @blur="SelctCbDocumentoNotaDebitoBanco"
                            @focus="cargarDocumentoNotaDebitoBanco"
                            style="font-size: 13px"
                            hide-details
                          >
                          <template v-slot:selection="{ attrs, item, parent, selected }">
                          <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.descripcion.trim()}}</span>
                           <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                           </template>

                            <template v-slot:prepend-inner>
                              <i style="font-size: 20px" class="fa fa-book"></i>
                            </template>
                          </v-combobox>
                    </v-col>
                    
                      </v-col>
                      <!-- fin col 1  ---------------------------------------->

                      <!-- col 2  ---------------------------------------->
                      <v-col cols="12" md="6" sm="6"  >
                     <!--  2- col 7- Codificación gastos Formales  --------- -->
                        <v-col cols="12" md="12" sm="12" >
                           <v-btn color="teal darken-2" dark  small @click.prevent="getSqlCodificacioContable(7)">7- Codificación gastos Formales</v-btn>
                           <v-combobox class="pt-2 "
                            v-model="datoHeader.documentoGastosProFormales"
                            autocomplete="off"
                            dense
                            outlined
                            label="Documentos Gastos Formales:"
                            :items="RDocumentoGastosProFormales"
                            item-text="descripcion"
                            @blur="SelctCbDocumentoGastosProFormales"
                            @focus="cargarDocumentoGastosProFormales"
                            style="font-size: 13px"
                            hide-details
                          >
                          <template v-slot:selection="{ attrs, item, parent, selected }">
                          <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.descripcion.trim()}}</span>
                           <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                           </template>

                            <template v-slot:prepend-inner>
                              <i style="font-size: 20px" class="fa fa-book"></i>
                            </template>
                          </v-combobox>
                        </v-col>
                        <!--  2- col 8- Codificación Gastos Informales  --------- -->
                        <v-col cols="12" md="12" sm="12" >
                           <v-btn color="teal darken-2" dark  small @click.prevent="getSqlCodificacioContable(8)"> 8- Codificación Gastos Informales</v-btn>
                           <v-combobox class="pt-2 "
                            v-model="datoHeader.documentoGastosProInFormales"
                            autocomplete="off"
                            dense
                            outlined
                            label="Documentos Gastos Informales:"
                            :items="RDocumentoGastosProInFormales"
                            item-text="descripcion"
                            @blur="SelctCbDocumentoGastosProInFormales"
                            @focus="cargarDocumentoGastosProInFormales"
                            style="font-size: 13px"
                            hide-details
                          >
                          <template v-slot:selection="{ attrs, item, parent, selected }">
                          <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.descripcion.trim()}}</span>
                           <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                           </template>

                            <template v-slot:prepend-inner>
                              <i style="font-size: 20px" class="fa fa-book"></i>
                            </template>
                          </v-combobox>
                        </v-col>
                        <!--  2- col 9- Codificación Devolución --------- -->
                        <v-col cols="12" md="12" sm="12" >
                          <v-btn color="teal darken-2" dark  small @click.prevent="getSqlCodificacioContable(9)"> 9- Codificación Devolución Proveedores</v-btn>
                          <v-combobox class="pt-2 "
                            v-model="datoHeader.documentoDevolucionProveedores"
                            autocomplete="off"
                            dense
                            outlined
                            label="Documentos Codificación Devolución Proveedores:"
                            :items="RDocumentoDevolucionProveedores"
                            item-text="descripcion"
                            @blur="SelctCbDocumentoDevolucionProveedores"
                            @focus="cargarDocumentoDevolucionProveedores"
                            style="font-size: 13px"
                            hide-details
                          >

                          <template v-slot:selection="{ attrs, item, parent, selected }">
                          <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.descripcion.trim()}}</span>
                           <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                           </template>

                            <template v-slot:prepend-inner>
                              <i style="font-size: 20px" class="fa fa-book"></i>
                            </template>
                          </v-combobox>
                        </v-col>
                        <!--  2- col 10- Codificación Cheques --------- -->
                        <v-col cols="12" md="12" sm="12" >
                          <v-btn color="teal darken-2" dark  small @click.prevent="getSqlCodificacioContable(10)">10- Codificación Cheques</v-btn>
                          <v-combobox class="pt-2 "
                            v-model="datoHeader.documentoCheque"
                            autocomplete="off"
                            dense
                            outlined
                            label="Documentos Cheques:"
                            :items="RDocumentoCheque"
                            item-text="descripcion"
                            @blur="SelctCbDocumentoCheque"
                            @focus="cargarDocumentoCheque"
                            style="font-size: 13px"
                            hide-details
                          >
                          <template v-slot:selection="{ attrs, item, parent, selected }">
                          <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.descripcion.trim()}}</span>
                           <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                           </template>

                            <template v-slot:prepend-inner>
                              <i style="font-size: 20px" class="fa fa-book"></i>
                            </template>
                          </v-combobox>
                        </v-col>

                        <!--  2- col 11- Codificación Facturas Compras Proveedores --------- -->
                        <v-col cols="12" md="12" sm="12" >
                          <v-btn color="teal darken-2" dark  small @click.prevent="getSqlCodificacioContable(11)">11- Codificación Facturas Compras Proveedores</v-btn>
                          <v-combobox class="pt-2 "
                            v-model="datoHeader.documentoFacCompProveedore"
                            autocomplete="off"
                            dense
                            outlined
                            label="Documentos Facturas Compras Proveedores:"
                            :items="RDocumentoFacCompProveedore"
                            item-text="descripcion"
                            @blur="SelctCbDocumentoFacCompProveedore"
                            @focus="cargarDocumentoFacCompProveedore"
                            style="font-size: 13px"
                            hide-details
                          >
                          <template v-slot:selection="{ attrs, item, parent, selected }">
                          <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.descripcion.trim()}}</span>
                           <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                           </template>

                            <template v-slot:prepend-inner>
                              <i style="font-size: 20px" class="fa fa-book"></i>
                            </template>
                          </v-combobox>
                        </v-col>
                        <!--  2- col 12- Codificación Depósitos Bancos  --------- -->
                        <v-col cols="12" md="12" sm="12" >
                          <v-btn color="teal darken-2" dark  small @click.prevent="getSqlCodificacioContable(12)">12- Codificación Depósitos Bancos</v-btn>
                            <v-combobox class="pt-2 "
                            v-model="datoHeader.documentoDepositoBancarios"
                            autocomplete="off"
                            dense
                            outlined
                            label="Documentos Depósitos Bancos:"
                            :items="RDocumentoDepositoBancarios"
                            item-text="descripcion"
                            @blur="SelctCbDocumentoDepositoBancarios"
                            @focus="cargarDocumentoDepositoBancarios"
                            style="font-size: 13px"
                            hide-details
                          >
                          <template v-slot:selection="{ attrs, item, parent, selected }">
                          <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.descripcion.trim()}}</span>
                           <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                           </template>

                            <template v-slot:prepend-inner>
                              <i style="font-size: 20px" class="fa fa-book"></i>
                            </template>
                          </v-combobox>
                          
                        </v-col>
                      </v-col>
                      <!-- fin col 2  ---------------------------------------->
                  </v-row>
                    </v-col>
              <!-- fn col btn row 1  ---------------------------------------->
              
                </v-form>

        
                

              </div>
            </v-card>

          </div>
        </v-app>
      </td>
      <!-- fn contenido central ------------------------------------------------------------------------------------->
      <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
      <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraSecundariaAprir">
        <div
          class="overflow-y-auto"
          v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
        >
          <!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
        </div>
      </td>
      <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      label="myAlert"
      v-model="acti_tb_data"
      persistent
      max-width="100%"
      max-height="100%"
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light">REPORTE</v-toolbar-title>
          <i style="font-size: 20px" class="fa fa-file-pdf-o"></i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i style="font-size: 20px; color: #dd4b39" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" @keyup="filtro" label="Buscar" single-line hide-details>
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="slotHtabla"
              dense
              :items="list"
              :search="search"
              @click:row="datostabla"
              :footer-props="arrayPropiedases"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog label="myAlert" v-model="Elim_notif.estado" persistent max-width="350" transition="fab-transition">
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn @click.prevent="eliminar(), (Elim_notif.estado = !Elim_notif.estado)" small>
            <i style="font-size: 20px" class="fa fa-check"></i>
            Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px" class="fa fa-ban"></i>
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog label="myAlert" v-model="notif.estado" persistent max-width="350" transition="fab-transition">
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            v-if="(notif.Exec = 'ResFacVent')"
            @click.prevent="restaurarFacVenta(), (notif.estado = !notif.estado)"
            small
          >
            <i style="font-size: 20px" class="fa fa-check"></i>
            Si
          </v-btn>

          <v-btn @click.prevent="notif.estado = !notif.estado" small>
            <i style="font-size: 20px" class="fa fa-ban"></i>
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%"
      :vertical="true"
      :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialogReporte" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="grey darken-2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-toolbar-title v-on="on">Imprecion de reporte</v-toolbar-title>
            </template>
            <i style="font-size: 20px" dark dense class="fa fa-info-circle">
              <span>Imprecion:</span>
              Vista e Imprecion del reporte
            </i>
          </v-tooltip>

          <!-- <v-toolbar-title>Ordenes De Compras sugeridas</v-toolbar-title> -->

          <v-spacer></v-spacer>

          <v-btn color="grey darken-4" fab small @click="NewReporte">
            <i style="font-size: 20px; color: white" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-list three-line subheader>
          <pdf-app style="height: 100vh" :pdf="pdf" :config="config"></pdf-app>
        </v-list>
      </v-card>
    </v-dialog>

  
    <v-dialog v-model="Reparaloading" persistent width="300">
      <v-card color="grey darken-2" dark>
        <v-card-text>
          Espere...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import { EventBus } from "../event-bus"
  import BarraBusqueda2 from "../components/BarraBusquedaDinam"
  import VueAutonumeric from "../components/AutoNumericNuevo"
  import ContenidoBase from "../components/ContenidoBase"
  import { currencyFormatter, FormatoFecha, HoraFormatter, fechaNueva, getHoraActual } from "@/js/Funciones.js"
  export default {
    components: {
      BarraBusqueda2,
      VueAutonumeric,
      PdfApp: window["pdf-viewer"],
      ContenidoBase,
    },

    created() {
      var json = {
        titulo: "Utilitario Codificación Contable",
        descripcion: "Utilitario Codificación Contable",
        save: true,
        eliminar: false,
        anular: false,
        nuevo: true,
        imprimir: false,
        btnBarraDi: false,
        recalcular: true,

        accion: [
          "UtilitarioFactVentNew",
          "UtilitarioFactVentSave",
          "UtilitarioFactVentRemove",
          "UtilitarioFactVentAnular",
          "UtilitarioFactVentPrintList",
          "UtilitarioFactVentVercuenta",
          "UtilitarioFactVentCorreo",
          "UtilitarioFactVentRecalcular",
        ],
      }
      EventBus.$emit("anularBotonesAccion", json)
    },
    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      EventBus.$on("UtilitarioFactVentNew", this.newwnuevo)
      EventBus.$on("UtilitarioFactVentSave", this.save)
      EventBus.$on("UtilitarioFactVentRemove", this.remove)
      EventBus.$on("UtilitarioFactVentAnular", this.remove)
      EventBus.$on("UtilitarioFactVentPrintList", this.imprimirList)
      EventBus.$on("UtilitarioFactVentRecalcular", this.Recalcular)
      // this.cargarTodo();
      EventBus.$on("onResize", this.onResize)
    },

    data: () => ({
      arrayPropiedases: {
        "items-per-page-options": [10, 15, 20, 50],
        "items-per-page-text": "Cantidad de Registros Por Paginas",
        showFirstLastPage: false,
      },
 
      config: { findbar: false },
      pdf: "",
      windowSize: { width: "auto", height: "auto" },
      Reparaloading: false,
      dialogReporte: false,

      RDocumentoFactVent:[],
      RDocumentoDevVent:[],
      RDocumentoNotaCreditoCxc:[],
      RDocumentoOtrosIngreso:[],
      RDocumentoReciboIngreso:[],
      RDocumentoNotaDebitoBanco:[],
      RDocumentoGastosProFormales:[],
      RDocumentoGastosProInFormales:[],
      RDocumentoDevolucionProveedores:[],
      RDocumentoCheque:[],
      RDocumentoFacCompProveedore:[],
      RDocumentoDepositoBancarios:[],
      datoHeader: {
        fechaInicial: fechaNueva(),
        fechaFinal: fechaNueva(),
        documentoFactVent: null,
        documentoDevVent:null,
        documentoNotaCreditoCxc:null,
        documentoOtrosIngreso:null,
        documentoReciboIngreso:null,
        documentoNotaDebitoBanco:null,
        documentoGastosProFormales:null,
        documentoGastosProInFormales:null,
        documentoDevolucionProveedores:null,
        documentoCheque:null,
        documentoFacCompProveedore:null,
        documentoDepositoBancarios:null
      },

      UtilCodificacionContable: {},

      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: true,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

  
      text: "",
      valid: true,
      BarraPrimariaAbrir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:",
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" },
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?",
      },

      notif: {
        estado: false,
        nombre: "",
        Exec: "",
      },

      aalert: {
        estado: false,
        color: null,
      },
    }),

    //   destroyed() {
    //     location.reload();
    //   },
    methods: {
      currencyFormatter,
      FormatoFecha,
      HoraFormatter,
      fechaNueva,
      getHoraActual,
      onResize(e) {
        // this.windowSize=e
      },

      abrirTabla() {
        this.BarraPrimariaAbrir = !this.BarraPrimariaAbrir
      },
      async cargarTodo() {},

      datostabla(e) {},
      save() {},
      saveCont() {},
      remove() {},
      eliminar() {},
      anular() { },
      imprimirList() {},
      newwnuevo() {

        ;(this.datoHeader = {
          cliente: null,
          fechaInicial: fechaNueva(),
          fechaFinal: fechaNueva(),
          NoFactura: 0,
          documento: null,
          ncf: null,
        }),
          
        EventBus.$emit("loading", false)
        //   EventBus.$emit("actualizaBarraBusqueda2");
      },

      NewReporte() {
        this.dialogReporte = false
      },

      imprimiir() {
        window.print()
      },


      
     
   
  
   
      KeyUpCantidad(e) {
        //  if(e.key.charCodeAt(0)>=48 & e.key.charCodeAt(0)<=57 ){}

        if (e.target.value.length == 0) {
          e.target.value = 0
        }

        if (e.key) {
          var mynumeral = require("numeral")
          e.target.value = mynumeral(e.target.value).value()

          //console.log(mynumeral(""+this.mensajero.metadeenvios)).value()
          if (e.target.value == null) {
            e.target.value = 0
          }
        } else {
          e.key = ""

          //console.log("no se puede poner letras o signos")
        }

        if (e.target.value.length == 0) {
          e.target.value = 0
          e.key = 0
        }
      },

 

    
      getPdf() {
        const pdff =
          "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"

        this.pdf = this.base64ToArrayBuffer(pdff)
      },

      base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64)
        var len = binary_string.length
        var bytes = new Uint8Array(len)
        for (var i = 0; i < len; i++) {
          bytes[i] = binary_string.charCodeAt(i)
        }
        return bytes.buffer
      },

  
      NotifrestaurarFacVenta() {
        var notif = {
          estado: true,
          nombre: "¿Seguro que desea restaurar los producto de esta factura?",
          Exec: "ResFacVent",
        }

        this.Exec_notif(notif)
      },

      Exec_notif(e) {
        //console.log(e)
        this.notif = JSON.parse(JSON.stringify(e))

        //this.Elim_notif.estado = !this.Elim_notif.estado;
      },

      BlurDesde() {
        if (this.datoHeader.fechaInicial.toString().length == 0) {
          this.datoHeader.fechaInicial = this.fechaNueva()
        }
      },

      BlurHasta() {
        if (this.datoHeader.fechaFinal.toString().length == 0) {
          this.datoHeader.fechaFinal = this.fechaNueva()
        }
      },


      cargarDocumentoFactVent() {
        this.$axios
          .get(this.$hostname + this.$hName + "/documentoventas/findallActivos", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.RDocumentoFactVent = res.data.filter((ee) => ee.operacion.codigo == 27)
          })
      },

      SelctCbDocumentoFacVent() {
        var _this = this
        setTimeout(function () {
          if (_this.datoHeader.documentoFactVent == null) {
            _this.datoHeader.documentoFactVent = ""
          }

          if (!_this.datoHeader.documentoFactVent.hasOwnProperty("codigo")) {
            _this.datoHeader.documentoFactVent = ""
            _this.datoHeader.documentoFactVent = null
            // _this.alerta("Seleccione un documento facturas ventas", "error")
            return
          }
        }, 300)
      },

      cargarDocumentoDevVent() {
 this.$axios.get(this.$hostname + this.$hName +"/documento-inv/devolucion",
        { headers: this.$store.getters.GetheadersAxios })
        .then(res => {this.RDocumentoDevVent = res.data;});
      },

      SelctCbDocumentoDevVent() {
        var _this = this
        setTimeout(function () {
          if (_this.datoHeader.documentoDevVent == null) {
            _this.datoHeader.documentoDevVent = ""
          }

          if (!_this.datoHeader.documentoDevVent.hasOwnProperty("codigo")) {
            _this.datoHeader.documentoDevVent = ""
            _this.datoHeader.documentoDevVent = null
            // _this.alerta("Seleccione un documento devolucion", "error")
            return
          }
        }, 300)
      },

      cargarDocumentoNotaCreditoCxc() {
        
        this.$axios.get(this.$hostname + this.$hName + '/documentocxc/findallCXCNotaCredito', { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RDocumentoNotaCreditoCxc = res.data))
      },

      SelctCbDocumentoNotaCreditoCxc() {
        var _this = this
        setTimeout(function () {
          if (_this.datoHeader.documentoNotaCreditoCxc == null) {
            _this.datoHeader.documentoNotaCreditoCxc = ""
          }

          if (!_this.datoHeader.documentoNotaCreditoCxc.hasOwnProperty("codigo")) {
            _this.datoHeader.documentoNotaCreditoCxc = ""
            _this.datoHeader.documentoNotaCreditoCxc = null
            // _this.alerta("Seleccione un documento Nota crédito ", "error")
            return
          }
        }, 300)
      },

      cargarDocumentoOtrosIngreso() {

  this.$axios.get(this.$hostname + this.$hName +"/documentocxc/findallOtrosIngreso",
        { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.RDocumentoOtrosIngreso = res.data;
        });
        
      },

      SelctCbDocumentoOtrosIngresos() {
        var _this = this
        setTimeout(function () {
          if (_this.datoHeader.documentoOtrosIngreso == null) {
            _this.datoHeader.documentoOtrosIngreso = ""
          }

          if (!_this.datoHeader.documentoOtrosIngreso.hasOwnProperty("codigo")) {
            _this.datoHeader.documentoOtrosIngreso = ""
            _this.datoHeader.documentoOtrosIngreso = null
            // _this.alerta("Seleccione un documento Otros recibos de ingreso ", "error")
            return
          }
        }, 300)
      },

      cargarDocumentoReciboIngreso() {

  this.$axios.get(this.$hostname +this.$hName +"/documentocxc/findallReciboIngreso",
          { headers: this.$store.getters.GetheadersAxios }
        ).then(res => {
          this.RDocumentoReciboIngreso = res.data;
        });
        
      },

      SelctCbDocumentoReciboIngreso() {
        var _this = this
        setTimeout(function () {
          if (_this.datoHeader.documentoReciboIngreso == null) {
            _this.datoHeader.documentoReciboIngreso = ""
          }

          if (!_this.datoHeader.documentoReciboIngreso.hasOwnProperty("codigo")) {
            _this.datoHeader.documentoReciboIngreso = ""
            _this.datoHeader.documentoReciboIngreso = null
            // _this.alerta("Seleccione un documento Recibos de Ingreso ", "error")
            return
          }
        }, 300)
      },

      cargarDocumentoNotaDebitoBanco() {
      this.$axios.get(this.$hostname + this.$hName + '/documentobanco/documentonotadebito',
        { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RDocumentoNotaDebitoBanco = res.data))
      },

      SelctCbDocumentoNotaDebitoBanco() {
        var _this = this
        setTimeout(function () {
          if (_this.datoHeader.documentoNotaDebitoBanco == null) {
            _this.datoHeader.documentoNotaDebitoBanco = ""
          }

          if (!_this.datoHeader.documentoNotaDebitoBanco.hasOwnProperty("codigo")) {
            _this.datoHeader.documentoNotaDebitoBanco = ""
            _this.datoHeader.documentoNotaDebitoBanco = null
            // _this.alerta("Seleccione un documento Nota debito banco ", "error")
            return
          }
        }, 300)
      },

      cargarDocumentoGastosProFormales() {
        
     this.$axios.get(this.$hostname + this.$hName + '/documentosgastos/gastoProveedoresFormales',
        { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RDocumentoGastosProFormales = res.data))
      },

      SelctCbDocumentoGastosProFormales() {
        var _this = this
        setTimeout(function () {
          if (_this.datoHeader.documentoGastosProFormales == null) {
            _this.datoHeader.documentoGastosProFormales = ""
          }

          if (!_this.datoHeader.documentoGastosProFormales.hasOwnProperty("codigo")) {
            _this.datoHeader.documentoGastosProFormales = ""
            _this.datoHeader.documentoGastosProFormales = null
            // _this.alerta("Seleccione un documento gastos proveedor formal ", "error")
            return
          }
        }, 300)
      },

      cargarDocumentoGastosProInFormales() {

         this.$axios.get(this.$hostname + this.$hName + '/documentosgastos/gastoProveedoresInformales',
        { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RDocumentoGastosProInFormales = res.data))
        
      },

      SelctCbDocumentoGastosProInFormales() {
        var _this = this
        setTimeout(function () {
          if (_this.datoHeader.documentoGastosProInFormales == null) {
            _this.datoHeader.documentoGastosProInFormales = ""
          }

          if (!_this.datoHeader.documentoGastosProInFormales.hasOwnProperty("codigo")) {
            _this.datoHeader.documentoGastosProInFormales = ""
            _this.datoHeader.documentoGastosProInFormales = null
            // _this.alerta("Seleccione un documento gastos proveedor informal ", "error")
            return
          }
        }, 300)
      },

      cargarDocumentoDevolucionProveedores() {

    this.$axios.get(this.$hostname + this.$hName + '/documentoscxp/findAllDocumentosDevolucionProveedores',
            { headers: this.$store.getters.GetheadersAxios })
            .then(res => (this.RDocumentoDevolucionProveedores = res.data))

      },

      SelctCbDocumentoDevolucionProveedores() {
        var _this = this
        setTimeout(function () {
          if (_this.datoHeader.documentoDevolucionProveedores == null) {
            _this.datoHeader.documentoDevolucionProveedores = ""
          }

          if (!_this.datoHeader.documentoDevolucionProveedores.hasOwnProperty("codigo")) {
            _this.datoHeader.documentoDevolucionProveedores = ""
            _this.datoHeader.documentoDevolucionProveedores = null
            // _this.alerta("Seleccione un documento Devolución Proveedores ", "error")
            return
          }
        }, 300)
      },

      cargarDocumentoCheque() {
        this.$axios
          .get(this.$hostname + this.$hName + "/documentobanco/findallactivo", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.RDocumentoCheque = res.data.filter((ee) => ee.operacion.codigo == 14)
          })
      },

      SelctCbDocumentoCheque() {
        var _this = this
        setTimeout(function () {
          if (_this.datoHeader.documentoCheque == null) {
            _this.datoHeader.documentoCheque = ""
          }

          if (!_this.datoHeader.documentoCheque.hasOwnProperty("codigo")) {
            _this.datoHeader.documentoCheque = ""
            _this.datoHeader.documentoCheque = null
            // _this.alerta("Seleccione un documento Cheque", "error")
            return
          }
        }, 300)
      },

      cargarDocumentoFacCompProveedore() {
  this.$axios.get(this.$hostname +this.$hName +"/documentoscxp/findAllDocumentosFacturasProveedores",
          { headers: this.$store.getters.GetheadersAxios }
        ).then((res) => (this.RDocumentoFacCompProveedore = res.data));
      },

      SelctCbDocumentoFacCompProveedore() {
        var _this = this
        setTimeout(function () {
          if (_this.datoHeader.documentoFacCompProveedore == null) {
            _this.datoHeader.documentoFacCompProveedore = ""
          }

          if (!_this.datoHeader.documentoFacCompProveedore.hasOwnProperty("codigo")) {
            _this.datoHeader.documentoFacCompProveedore = ""
            _this.datoHeader.documentoFacCompProveedore = null
            // _this.alerta("Seleccione un documento Facturas Compras Proveedores", "error")
            return
          }
        }, 300)
      },

      cargarDocumentoDepositoBancarios() {

    this.$axios.get(this.$hostname + this.$hName + '/documentobanco/documentodeposito',
        { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RDocumentoDepositoBancarios = res.data))

      },

      SelctCbDocumentoDepositoBancarios() {
        var _this = this
        setTimeout(function () {
          if (_this.datoHeader.documentoDepositoBancarios == null) {
            _this.datoHeader.documentoDepositoBancarios = ""
          }

          if (!_this.datoHeader.documentoDepositoBancarios.hasOwnProperty("codigo")) {
            _this.datoHeader.documentoDepositoBancarios = ""
            _this.datoHeader.documentoDepositoBancarios = null
            // _this.alerta("Seleccione un documento Facturas Compras Proveedores", "error")
            return
          }
        }, 300)
      },



      getSqlCodificacioContable(OPC){
        EventBus.$emit("loading", true)

        var sql="";
        var schema=this.$store.getters.GetheadersAxios["X-TENANT-ID"];
        var desde= this.datoHeader.fechaInicial
        var hasta= this.datoHeader.fechaFinal

//1- Codificación Facturas Ventas
if(OPC===1){
  var qrydoc= this.datoHeader.documentoFactVent!=null && this.datoHeader.documentoFactVent.hasOwnProperty("codigo")?` and documento=${this.datoHeader.documentoFactVent.codigo}`:'';
//sql=`select ${schema}.codificacion(secuencia,documento) from ${schema}.facturasventa where fecha>='${desde}' and fecha<='${hasta}' and activada=true ${qrydoc} and (documento,secuencia) not in (select documento,secuencia from ${schema}.contabilidad where modulo='PV')`
sql=`select ${schema}.codificacion(secuencia,documento) from ${schema}.facturasventa where fecha>='${desde}' and fecha<='${hasta}' and activada=true ${qrydoc}`
}
//2- Codificación devoluciones Punto
if(OPC===2){
  // codificacion_devolucion(secuencia integer,documento integer)
  var qrydoc= this.datoHeader.documentoDevVent!=null && this.datoHeader.documentoDevVent.hasOwnProperty("codigo")?` and documento=${this.datoHeader.documentoDevVent.codigo}`:'';
  //sql=`select ${schema}.codificacion_devolucion(secuencia,documento) from ${schema}.devoclucion where fecha>='${desde}' and fecha<='${hasta}' and activo=true ${qrydoc} and (documento,secuencia) not in (select documento,secuencia from ${schema}.contabilidad where modulo='INV')`
sql=`select ${schema}.codificacion_devolucion(secuencia,documento) from ${schema}.devoclucion where fecha>='${desde}' and fecha<='${hasta}' and activo=true ${qrydoc} `
}
//3- Codificación Notas Crédito Clientes CXC
if(OPC===3){
// codificacion_notacreditoclientes(secuencia integer,documento integer)
 var qrydoc= this.datoHeader.documentoNotaCreditoCxc!=null && this.datoHeader.documentoNotaCreditoCxc.hasOwnProperty("codigo")?` and documento=${this.datoHeader.documentoNotaCreditoCxc.codigo}`:'';
 // sql=`select ${schema}.codificacion_notacreditoclientes(secuencia,documento) from ${schema}.notacreditoclientes where fecha>='${desde}' and fecha<='${hasta}' and activada=true ${qrydoc} and (documento,secuencia) not in (select documento,secuencia from ${schema}.contabilidad where modulo='CXC')`
 sql=`select ${schema}.codificacion_notacreditoclientes(secuencia,documento) from ${schema}.notacreditoclientes where fecha>='${desde}' and fecha<='${hasta}' and activada=true ${qrydoc} `
}
//4- Codificación Recibos Otros Ingresos
if(OPC===4){
 // codificacion_otros_ingreso(secuencia integer,documento integer)
  var qrydoc= this.datoHeader.documentoOtrosIngreso!=null && this.datoHeader.documentoOtrosIngreso.hasOwnProperty("codigo")?` and documento=${this.datoHeader.documentoOtrosIngreso.codigo}`:'';
 // sql=`select ${schema}.codificacion_otros_ingreso(secuencia,documento) from ${schema}.recibosotrosingreso where fecha>='${desde}' and fecha<='${hasta}' and activo=true ${qrydoc} and (documento,secuencia) not in (select documento,secuencia from ${schema}.contabilidad where modulo='CXC')`
  sql=`select ${schema}.codificacion_otros_ingreso(secuencia,documento) from ${schema}.recibosotrosingreso where fecha>='${desde}' and fecha<='${hasta}' and activo=true ${qrydoc} `
}
//5- Codificación Recibos de Ingreso
if(OPC===5){
// .codificacion_recibos_ingreso(secuencia integer,documento integer)
 var qrydoc= this.datoHeader.documentoReciboIngreso!=null && this.datoHeader.documentoReciboIngreso.hasOwnProperty("codigo")?` and documento=${this.datoHeader.documentoReciboIngreso.codigo}`:'';
  //sql=`select ${schema}.codificacion_recibos_ingreso(secuencia,documento) from ${schema}.recibosdeingreso where fecha>='${desde}' and fecha<='${hasta}' and activo=true ${qrydoc} and (documento,secuencia) not in (select documento,secuencia from ${schema}.contabilidad where modulo='CXC')`
sql=`select ${schema}.codificacion_recibos_ingreso(secuencia,documento) from ${schema}.recibosdeingreso where fecha>='${desde}' and fecha<='${hasta}' and activo=true ${qrydoc} `

}
//6- Codificación Notas Debito Banco
if(OPC===6){
  var qrydoc= this.datoHeader.documentoNotaDebitoBanco!=null && this.datoHeader.documentoNotaDebitoBanco.hasOwnProperty("codigo")?` and documento=${this.datoHeader.documentoNotaDebitoBanco.codigo}`:'';
//sql=`select ${schema}.codificacion_notadebitobancos(secuencia,documento) from ${schema}.notadebitobancos where fecha>='${desde}' and fecha<='${hasta}' ${qrydoc} and activado=true and (documento,secuencia) not in (select documento,secuencia from ${schema}.contabilidad where modulo='BAN')`
sql=`select ${schema}.codificacion_notadebitobancos(secuencia,documento) from ${schema}.notadebitobancos where fecha>='${desde}' and fecha<='${hasta}' ${qrydoc} and activado=true `

}

//7- Codificación gastos Formales
if(OPC===7){
// .codificacion_formales(secuencia integer,documento integer)
var qrydoc= this.datoHeader.documentoGastosProFormales!=null && this.datoHeader.documentoGastosProFormales.hasOwnProperty("codigo")?` and documento=${this.datoHeader.documentoGastosProFormales.codigo}`:'';
  //sql=`select ${schema}.codificacion_formales(secuencia,documento) from ${schema}.gastos where fecha>='${desde}' and fecha<='${hasta}' and activado=true ${qrydoc} and (documento,secuencia) not in (select documento,secuencia from ${schema}.contabilidad where modulo='CONT')`
sql=`select ${schema}.codificacion_formales(secuencia,documento) from ${schema}.gastos where fecha>='${desde}' and fecha<='${hasta}' and activado=true ${qrydoc} `
}
//8- Codificación Gastos Informales
if(OPC===8){
// .codificacion_informales(secuencia integer,documento integer)
var qrydoc= this.datoHeader.documentoGastosProInFormales!=null && this.datoHeader.documentoGastosProInFormales.hasOwnProperty("codigo")?` and documento=${this.datoHeader.documentoGastosProInFormales.codigo}`:'';
  //sql=`select ${schema}.codificacion_informales(secuencia,documento) from ${schema}.gastos where fecha>='${desde}' and fecha<='${hasta}' and activado=true ${qrydoc} and (documento,secuencia) not in (select documento,secuencia from ${schema}.contabilidad where modulo='CONT')`
  sql=`select ${schema}.codificacion_informales(secuencia,documento) from ${schema}.gastos where fecha>='${desde}' and fecha<='${hasta}' and activado=true ${qrydoc} `
}
//9- Codificación Devolución Proveedor
if(OPC===9){
//.codificacion_dev(secuencia integer,documento integer)
var qrydoc= this.datoHeader.documentoDevolucionProveedores!=null && this.datoHeader.documentoDevolucionProveedores.hasOwnProperty("codigo")?` and documento=${this.datoHeader.documentoDevolucionProveedores.codigo}`:'';
  //sql=`select ${schema}.codificacion_dev(secuencia,documento) from ${schema}.devolucionproveedor where fecha>='${desde}' and fecha<='${hasta}' and activo=true ${qrydoc} and (documento,secuencia) not in (select documento,secuencia from ${schema}.contabilidad where modulo='CXP')`
  sql=`select ${schema}.codificacion_dev(secuencia,documento) from ${schema}.devolucionproveedor where fecha>='${desde}' and fecha<='${hasta}' and activo=true ${qrydoc} `
}
//10- Codificación Cheques
if(OPC===10){
var qrydoc= this.datoHeader.documentoCheque!=null && this.datoHeader.documentoCheque.hasOwnProperty("codigo")?` and documento=${this.datoHeader.documentoCheque.codigo}`:'';
  //sql=`select ${schema}.codificacion_cheques(secuencia,documento) from ${schema}.cheques where fecha>='${desde}' and fecha<='${hasta}' and activo=true  and anulado=false ${qrydoc} and (documento,secuencia) not in (select documento,secuencia from ${schema}.contabilidad where modulo='BAN')`;
  sql=`select ${schema}.codificacion_cheques(secuencia,documento) from ${schema}.cheques where fecha>='${desde}' and fecha<='${hasta}' and activo=true  and anulado=false ${qrydoc} `;
}
//11- Codificación Facturas Compras Proveedores
if(OPC===11){
  var qrydoc= this.datoHeader.documentoFacCompProveedore!=null && this.datoHeader.documentoFacCompProveedore.hasOwnProperty("codigo")?` and documento=${this.datoHeader.documentoFacCompProveedore.codigo}`:'';
  //sql=`SELECT ${schema}.codificacioncompra(fp.codigo, fp.documento) FROM ${schema}.facturas_proveedores fp WHERE fp.fecha>='${desde}' AND fp.fecha<='${hasta}' And activada=True ${qrydoc} and (documento,codigo) not in (select documento,codigo from ${schema}.contabilidad where modulo='CXP') `;
  sql=`SELECT ${schema}.codificacioncompra(fp.codigo, fp.documento) FROM ${schema}.facturas_proveedores fp WHERE fp.fecha>='${desde}' AND fp.fecha<='${hasta}' And activada=True ${qrydoc} `;
}
//12- Codificación Depósitos Bancos
if(OPC===12){
  //codificacion_deposito(secuencia integer,documento integer)
 var qrydoc= this.datoHeader.documentoDepositoBancarios!=null && this.datoHeader.documentoDepositoBancarios.hasOwnProperty("codigo")?` and documento=${this.datoHeader.documentoDepositoBancarios.codigo}`:'';
  //sql=`select ${schema}.codificacion_deposito(secuencia,documento) from ${schema}.depositosbanco where fecha>='${desde}' and fecha<='${hasta}' and activado=true  ${qrydoc} and (documento,secuencia) not in (select documento,secuencia from ${schema}.contabilidad where modulo='BAN')`;
 sql=`select ${schema}.codificacion_deposito(secuencia,documento) from ${schema}.depositosbanco where fecha>='${desde}' and fecha<='${hasta}' and activado=true  ${qrydoc} `;
}

var obj={
 sqlqry:sql
}

this.$axios
        .post(this.$hostname + this.$hName +"/utilitarioCodificacionContable/getRunCodificacionContable",obj,{headers:this.$store.getters.GetheadersAxios})
        .then(res =>{ this.alerta("Dato ejecutado", "bien") })
        .catch(error => {this.alerta("Reporte no Impreso("+error+")", "error")});


      },




      alertaNotf(e, l) {
        if (l == "bien") {
          ;(this.aalert.estado = true), (this.aalert.color = "success"), (this.aalert.nombre = e)
          EventBus.$emit("loading", false)
          //this.new();
        }

        if (l == "error") {
          ;(this.aalert.estado = true), (this.aalert.color = "error"), (this.aalert.nombre = e)

          this.ejecucion = false
          EventBus.$emit("loading", false)
        }
      },

      alerta(e, l) {
        if (l == "bien") {
          ;(this.aalert.estado = true), (this.aalert.color = "success"), (this.aalert.nombre = e)

          this.newwnuevo()
        }

        if (l == "error") {
          ;(this.aalert.estado = true), (this.aalert.color = "error"), (this.aalert.nombre = e)

          this.ejecucion = false
          EventBus.$emit("loading", false)
        }
      },

      currencyFormatter(number) {
        //return this.formatNumber(params) + ".00";

        if (number == null) {
          number = 0
        }
        return number
          .toFixed(2)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")

        ///return this.formatNumber(params);

        //return params;
      },

      FormatoFecha(params0) {
        var params

        if (params0 != null) {
          params = new Date(params0).toISOString().substr(0, 10)
          if (params != null) {
            if (params.length > 0) {
              return params.substring(8, 10) + "-" + params.substring(5, 7) + "-" + params.substring(0, 4)
            }
          }
        } else {
          params = "N/A"
        }
      },

      actualiza_tb_ver() {
        this.acti_tb_data = !this.acti_tb_data
        this.filtro()
      },

      async filtro() {},
    },
    computed: {
      ActDescBtn() {
        this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))

        //EventBus.$emit("ActDesaBotones", objjct);

      },
    },
  }
</script>

<style>
  #ImputColorDisable {
    color: black;
  }
</style>
